export enum EExtraVillages {
  Similar,
  Nearby,
}

export const EXTRA_VILLAGES_TITLE_MAP: { [key: number]: string } = {
  [EExtraVillages.Nearby]: 'Ближайшие КП',
  [EExtraVillages.Similar]: 'Похожие КП',
};
